// Student Journey V2 -- the learn mode's suggested-topic list.
//
// The FALLBACK list (00_SCOPE_AND_DESIGN_REFERENCE.md §18.5 A4). Since package
// 36 (TC-2) the Setup lists the chapters of the course outline Subway reads
// for the Student, and uses this list only when that outline gives none. The
// chosen topic is part of the CAT-1A snapshot and, since TC-1, named in the
// conversation's first-turn context by Subway.
// These are exactly the lists the rendered reference `borna-student-journey-v2`
// offers -- keyed by the real catalog course `name` -- and no others. Any course
// without an entry gets the reference's own behaviour for it: an empty
// suggestion select, with "write it yourself" still available.
const TOPIC_SUGGESTIONS = {
  'math-10': [
    'مجموعه، الگو و دنباله',
    'مثلثات',
    'توان‌های گویا و عبارت‌های جبری',
    'معادله‌ها و نامعادله‌ها',
    'تابع',
    'شمارش بدون شمردن',
    'آمار و احتمال',
  ],
  'physics-10': [
    'فیزیک و اندازه‌گیری',
    'ویژگی‌های فیزیکی مواد',
    'کار، انرژی و توان',
    'دما و گرما',
  ],
  'physics-11': [
    'الکتریسیته ساکن',
    'جریان الکتریکی و مدارهای جریان مستقیم',
    'مغناطیس',
    'القای الکترومغناطیسی',
  ],
  'physics-12': [
    'حرکت بر خط راست',
    'دینامیک و حرکت دایره‌ای',
    'نوسان و موج',
    'فیزیک اتمی و هسته‌ای',
  ],
}

/**
 * @param {string} courseName -- an `education_courses.name`, e.g. 'math-10'
 * @returns {string[]}
 */
export function topicSuggestionsFor(courseName) {
  return TOPIC_SUGGESTIONS[courseName] || []
}
